import styled from "styled-components";
import { palette } from "../../styles/palette";

export const AudioHelpModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: ${palette.overlayDark};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const AudioHelpModalCard = styled.div`
  background: ${palette.white};
  border-radius: 8px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px ${palette.shadowStrong};
  position: relative;
`;

export const AudioHelpModalHeader = styled.div`
  position: relative;
  padding-top: 16px;
  padding-bottom: 8px;
  margin-bottom: 8px;
`;

export const AudioHelpModalCloseButton = styled.button`
  position: fixed;
  top: calc(50vh - 40vh + 16px);
  right: calc(50vw - 300px + 16px);
  background: transparent;
  border: none;
  color: ${palette.greyFont};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3001;
`;

export const AudioHelpModalTitle = styled.h2`
  color: ${palette.grenTitle};
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 24px 0;
  text-align: center;
`;

export const AudioHelpModalSubtitle = styled.p`
  color: ${palette.secondaryTextColor};
  font-size: 16px;
  margin: 0 0 16px 0;
  text-align: center;
  line-height: 1.5;
  padding-right: 40px;
`;

export const AudioHelpSection = styled.div`
  margin-bottom: 24px;
`;

export const AudioHelpSectionTitle = styled.h3`
  color: ${palette.grenTitle};
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AudioHelpList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: ${palette.secondaryTextColor};
`;

export const AudioHelpListItem = styled.li`
  margin-bottom: 8px;
  line-height: 1.5;
`;

export const AudioHelpModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 48px;
  width: 100%;
`;

export const AudioHelpModalButton = styled.button<{
  variant: "primary" | "secondary";
}>`
  background: ${({ variant }) =>
    variant === "primary" ? palette.orange : palette.white};
  color: ${({ variant }) =>
    variant === "primary" ? palette.white : palette.grenTitle};
  border: ${({ variant }) =>
    variant === "primary" ? "none" : `2px solid ${palette.grenTitle}`};
  border-radius: 8px;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;
  box-shadow: ${palette.boxShadowCard};

  &:hover {
    background: ${({ variant }) =>
      variant === "primary" ? palette.orangeTwo : palette.grenTitle};
    color: ${palette.white};
    transform: translateY(-1px);
  }
`;
